import { useQuery } from 'convex/react';
import { api } from '@aeon-karaoke/cloud-convex';
import type { Doc } from '@aeon-karaoke/cloud-convex/_generated/dataModel';

export type CurrentUser = Doc<'users'>;

interface UseCurrentUserResult {
  user: CurrentUser | null;
  isAdmin: boolean;
  isLoading: boolean;
}

/**
 * Server-resolved current user via `users.me`. Role is NEVER trusted from the
 * client — `isAdmin` reflects the server doc only. A null row (bootstrap
 * window) reports as loading; AccountGate owns creating the row.
 */
export function useCurrentUser(): UseCurrentUserResult {
  const user = useQuery(api.users.me);
  return {
    user: user ?? null,
    isAdmin: user?.role === 'admin',
    isLoading: user === undefined || user === null,
  };
}
